import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import api from "@/lib/api";

export default function AdminNewsletter() {
    const [subs, setSubs] = useState([]);
    useEffect(() => { api.get("/admin/newsletter").then(({ data }) => setSubs(data.subscribers)); }, []);

    const exportCsv = () => {
        const csv = "email,subscribed_at\n" + subs.map((s) => `${s.email},${s.created_at}`).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = "elvosh-subscribers.csv"; a.click();
    };

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-semibold">Newsletter Subscribers ({subs.length})</h1>
                <button data-testid="export-newsletter" onClick={exportCsv} className="bg-ink text-white px-4 py-2.5 rounded text-sm flex items-center gap-2"><Download className="h-4 w-4" /> Export CSV</button>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 border-b border-gray-200 text-gray-500 text-xs uppercase"><tr><th className="text-left p-4">Email</th><th className="text-left p-4">Subscribed</th></tr></thead>
                    <tbody className="divide-y divide-gray-100">
                        {subs.length === 0 ? <tr><td colSpan={2} className="p-8 text-center text-gray-400">No subscribers yet.</td></tr> :
                        subs.map((s) => <tr key={s.id}><td className="p-4">{s.email}</td><td className="p-4">{(s.created_at || "").slice(0, 10)}</td></tr>)}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
